"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.outbank = exports.outbankMatcher = exports.outbankParser = exports.parseNumber = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var papaparse_1 = require("../../util/papaparse");

var iban_1 = __importDefault(require("iban"));

var slugify_1 = __importDefault(require("slugify"));

exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{1,2})\/(\d{1,2})\/(\d{1,2})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: M/D/Y');
  }

  var month = match[1],
      day = match[2],
      year = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), "20" + year].join('/');
};

exports.parseNumber = function (input) {
  return Number(input.replace(',', '.'));
};

exports.outbankParser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var data, banks, groupedData, getBankSlug;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            header: true
          })];

        case 1:
          data = _a.sent().data;
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return __importStar(require('./blz.json'));
          })];

        case 2:
          banks = _a.sent()["default"];
          groupedData = data.filter(function (r) {
            return r.Date && r.Amount;
          }).reduce(function (acc, cur) {
            var data = {
              Date: exports.generateYnabDate(cur.Date),
              Payee: cur.Name || cur.Reason,
              Category: cur.Category,
              Memo: cur.Reason,
              Outflow: exports.parseNumber(cur.Amount) < 0 ? Math.abs(exports.parseNumber(cur.Amount)).toFixed(2) : undefined,
              Inflow: exports.parseNumber(cur.Amount) > 0 ? exports.parseNumber(cur.Amount).toFixed(2) : undefined
            };
            var key = cur.Account || 'no-account';

            if (Object.keys(acc).includes(key)) {
              acc[key].push(data);
            } else {
              acc[key] = [data];
            }

            return acc;
          }, {});

          getBankSlug = function getBankSlug(key) {
            return banks[key.substr(4, 8)] ? slugify_1["default"](banks[key.substr(4, 8)]).toLowerCase() : 'unknown';
          };

          return [2
          /*return*/
          , Object.keys(groupedData).map(function (key) {
            return {
              accountName: iban_1["default"].isValid(key) ? getBankSlug(key) : key,
              data: groupedData[key]
            };
          })];
      }
    });
  });
};

exports.outbankMatcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var requiredKeys, data, keys, missingKeys;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          requiredKeys = ['#', 'Account', 'Date', 'Value Date', 'Amount', 'Currency', 'Name', 'Number', 'Bank', 'Reason', 'Category'];
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            header: true
          })];

        case 1:
          data = _a.sent().data;

          if (data.length === 0) {
            return [2
            /*return*/
            , false];
          }

          keys = Object.keys(data[0]);
          missingKeys = requiredKeys.filter(function (k) {
            return !keys.includes(k);
          });

          if (missingKeys.length === 0) {
            return [2
            /*return*/
            , true];
          }

          return [2
          /*return*/
          , false];
      }
    });
  });
};

exports.outbank = {
  name: 'Outbank',
  country: 'de',
  fileExtension: 'csv',
  filenamePattern: /^Outbank_Export_(\d{8})\.csv/,
  link: 'https://help.outbankapp.com/en/kb/articles/wie-kann-ich-ums-tze-als-csv-datei-exportieren',
  match: exports.outbankMatcher,
  parse: exports.outbankParser
};